
export function capitalize(name: string): string {
    const words = name.split(' ');
    const processedWords = words.map(word => {
        const firstLetter = word.charAt(0).toUpperCase();
        const restOfWord = word.slice(1).toLowerCase();
        return firstLetter + restOfWord;
    });
    return processedWords.join(' ');           
}

declare global {
    interface String {
        capitalize(): string
    }
}

// eslint-disable-next-line no-extend-native
String.prototype.capitalize = function() {
    return capitalize(this.toString())
}

class Utils {
    static async sleep(timeInMilliseconds: number = 2000) {
         await new Promise(resolve => setTimeout(resolve, timeInMilliseconds));
    }
}


export default Utils;
